import { extendTheme, ChakraProvider, forwardRef, useMultiStyleConfig, Alert as Alert$1, Stack, AlertTitle, AlertDescription, CloseButton, useBreakpoint as useBreakpoint$1, useBreakpointValue as useBreakpointValue$1, Text, Code as Code$1, useCheckboxGroup, CheckboxGroup as CheckboxGroup$1, Checkbox as Checkbox$1, useControllableState, Slider as Slider$1, SliderTrack, SliderMark, SliderFilledTrack, SliderThumb, Switch, Select as Select$1, InputGroup, Input, InputLeftElement, InputRightElement, NumberInput, PinInput, Radio, Textarea, RadioGroup, AspectRatio, Center, Box as Box$1, Container, Flex, Grid, HStack, SimpleGrid, Spacer, VStack, Wrap, chakra, omitThemingProps, useFormControlContext, StylesProvider, FormLabel, RequiredIndicator, FormHelperText, FormControl, useNumberInput, Editable, EditableInput, EditableTextarea, EditablePreview, Tabs, TabList, TabPanels, Tab, TabPanel, useMenuButton, Menu as Menu$1, Portal, MenuList, MenuButton as MenuButton$1, MenuItemOption as MenuItemOption$1, MenuCommand, MenuDivider, MenuGroup, MenuIcon, MenuItem, MenuOptionGroup, Icon as Icon$1, ModalCloseButton as ModalCloseButton$1, ModalOverlay, ModalHeader, ModalBody, ModalFooter, AlertDialog, AlertDialogContent, Drawer as Drawer$1, DrawerContent, Modal as Modal$1, ModalContent, useModalContext, useDimensions, useMergeRefs, useModalStyles, ModalFocusScope, PopoverTrigger, PopoverAnchor, Popover as Popover$1, PopoverContent, PopoverArrow, PopoverCloseButton, PopoverHeader, PopoverBody, PopoverFooter, Tooltip as Tooltip$1, Image as Image$1, Badge as Badge$1, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Table, Tbody, Td, Tfoot, Th, Thead, Tr, Tag as Tag$1, TagLeftIcon, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { theme, mapResponsive } from '@hover/chakra-theme';
import { useState, useEffect, useMemo, useCallback, isValidElement, Children, cloneElement, useRef } from 'react';
import { f as useToastTargetRefs, P as Provider$2, F as Fonts, h as NextFeaturesProvider, I as Icon, C as ColorSchemeProvider, B as Button, b as useIsMotionReduced, u as useColorScheme, e as useIsNextFeatureEnabled, d as useNextThemeRootClassName, M as Motion } from './Link-f73d7087.esm.js';
import { g as applyNextTheme, _ as _objectWithoutProperties, a as _objectSpread2, L as Loader, w as withTestId, d as _slicedToArray, B as Box, u as useTheme, m as motion$1, c as _defineProperty, H as Heading } from './ProgressiveLoader-54b1969c.esm.js';
import { jsx, jsxs, Fragment } from '@emotion/react/jsx-runtime';
import { AnimatePresence, motion, MotionConfig, transform, useMotionValue, animate } from 'framer-motion';
import { transitions, math, lighten } from 'polished';
import _pick from 'ramda/src/pick';
import _omit from 'ramda/src/omit';
import { isDefined, omit, includes, invoke } from '@hover/utilities';
import _mapObjIndexed from 'ramda/src/mapObjIndexed';
import { useSize } from '@chakra-ui/react-use-size';
import { createContext } from '@chakra-ui/react-utils';
import { callAll } from '@chakra-ui/shared-utils';
import { textSizes } from '@hover/chakra-theme/components';
import { space, motion as motion$2 } from '@hover/chakra-theme/foundation';
import { propNames, layoutPropNames as layoutPropNames$1 } from '@chakra-ui/system';
import 'ramda/src/has';
import 'tiny-warning';
import 'ramda/src/join';
import 'ramda/src/identity';
import 'ramda/src/ifElse';
import 'ramda/src/map';
import 'ramda/src/split';
import 'ramda/src/concat';
import 'ramda/src/toLower';
import 'ramda/src/pipe';
import { useTheme as useTheme$1 } from '@emotion/react';
import 'ramda/src/mergeDeepLeft';
import 'ramda/src/mergeLeft';
import '@hover/chakra-theme/next';
import { iInfo, iAlertCircle, iCheckCircle, iLoader, iChevronDown, iMinus, iPlus, iFilter } from '@hover/icons';
import invariant from 'tiny-invariant';
import '@hover/tokens-typography';
import '@hover/tokens-typography/next';
import { RemoveScroll } from 'react-remove-scroll';
import { size50, size75, size100 } from '@hover/tokens-size';

/**
 * All system props. This is exactly the same as Chakra's
 * `propNames` export, but with a narrower/more accurate type.
 */
var systemPropNames = propNames;

/**
 * List of layout-related system props (layout, space, flexbox, grid
 * and position). This is exactly the same as Chakra's `layoutPropNames`
 * export, but with a narrower/more accurate type.
 */
var layoutPropNames = layoutPropNames$1;
/**
 * Split out layout-related system props from a props object. This is useful
 * when composing components and you want to pass most props to a specific
 * child component, but still want to support the layout APIs via a `Box`
 * or similar container component.
 *
 * @example
 * ```tsx
 * const CompositeComponent = (props: CompositeComponentProps) => {
 *   const { layoutProps, props: childProps } = splitLayoutProps(props);
 *
 *   return (
 *     <Box {...layoutProps}>
 *       <SomeComposedChakraComponent {...childProps} />
 *     </Box>
 *   );
 * }
 * ```
 *
 * @param props all component props
 * @returns an object with the separated props objects
 */
var splitSystemProps = function splitSystemProps(props) {
  return {
    systemProps: _pick(systemPropNames, props),
    props: _omit(systemPropNames, props)
  };
};
/**
 * Split out layout-related system props from a props object. This is useful
 * when composing components and you want to pass most props to a specific
 * child component, but still want to support the layout APIs via a `Box`
 * or similar container component.
 *
 * @example
 * ```tsx
 * const CompositeComponent = (props: CompositeComponentProps) => {
 *   const { layoutProps, props: childProps } = splitLayoutProps(props);
 *
 *   return (
 *     <Box {...layoutProps}>
 *       <SomeComposedChakraComponent {...childProps} />
 *     </Box>
 *   );
 * }
 * ```
 *
 * @param props all component props
 * @returns an object with the separated props objects
 */
var splitLayoutProps = function splitLayoutProps(props) {
  return {
    layoutProps: _pick(layoutPropNames, props),
    props: _omit(layoutPropNames, props)
  };
};

/**
 * Retrieve just the theming props (`variant`, `colorScheme`, `size`, etc.)
 * from a props object.
 *
 * @param props component props
 * @returns theming props from component props (if any)
 */
var pickThemingProps = function pickThemingProps(props) {
  var propNames = ['colorScheme', 'orientation', 'variant', 'size', 'styleConfig'];
  return _pick(propNames, props);
};

var componentMessage = function componentMessage(name, message) {
  return "<".concat(name, "> ").concat(message);
};

var SWIPE_THRESHOLD = 10000;
/**
 * Helper for invoking actions in response to swipe gestures. Given a swipe
 * axis and actions to invoke when swiping towards the start or end of said
 * axis, determine whether to invoke one of the provided actions depending on
 * whether the swipe in the respective direction passes the provided threshold.
 *
 * @param options swipe options
 *
 * @example
 * ```tsx
 * import { motion, Image, onSwipe } from '@hover/blueprint';
 *
 * const MotionImage = motion(Image);
 *
 * <MotionImage
 *   drag="x"
 *   onDragEnd={
 *     onSwipe({
 *       axis: 'x',
 *       start: () => console.log('swiped left'),
 *       end: () => console.log('swiped right')
 *     })
 *   }
 * />
 * ```
 *
 * @returns event handler to pass to `onDragEnd`
 */
var onSwipe = function onSwipe(_ref) {
  var axis = _ref.axis,
    start = _ref.start,
    end = _ref.end,
    none = _ref.none,
    _ref$force = _ref.force,
    forceThreshold = _ref$force === void 0 ? SWIPE_THRESHOLD : _ref$force,
    _ref$distance = _ref.distance,
    distanceThreshold = _ref$distance === void 0 ? Infinity : _ref$distance;
  return function (_, _ref2) {
    var offset = _ref2.offset,
      velocity = _ref2.velocity;
    var distance = offset[axis];
    var force = Math.abs(distance) * velocity[axis];
    if (distance < 0 && distance < -distanceThreshold || force < -forceThreshold) {
      start === null || start === void 0 ? void 0 : start(force);
    } else if (distance > distanceThreshold || force > forceThreshold) {
      end === null || end === void 0 ? void 0 : end(force);
    } else {
      none === null || none === void 0 ? void 0 : none(force);
    }
  };
};

var stylesToOmit = ['transform'];
var stripMotionFromVariants = function stripMotionFromVariants(variants, strip) {
  return _mapObjIndexed(function (variant) {
    return strip ? _omit(stylesToOmit, variant) : variant;
  }, variants);
};

var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(isDefined).join(' ');
};

var Provider$1 = function Provider(_ref) {
  var children = _ref.children,
    customTheme = _ref.customTheme,
    environment = _ref.environment,
    extraComponentThemes = _ref.extraComponentThemes,
    fontsHost = _ref.fontsHost,
    _ref$includeFonts = _ref.includeFonts,
    includeFonts = _ref$includeFonts === void 0 ? false : _ref$includeFonts,
    portalZIndex = _ref.portalZIndex,
    next = _ref.next,
    _ref$resetCSS = _ref.resetCSS,
    resetCSS = _ref$resetCSS === void 0 ? false : _ref$resetCSS;
  var theme$1 = customTheme !== null && customTheme !== void 0 ? customTheme : theme;
  var components = extraComponentThemes;
  var themeWithComponents = components ? extendTheme({
    components: components
  }, theme$1) : theme$1;
  var _useToastTargetRefs = useToastTargetRefs(),
    toastPortalRef = _useToastTargetRefs.toastPortalRef,
    toastTargetRef = _useToastTargetRefs.toastTargetRef;
  return jsx(ChakraProvider, {
    cssVarsRoot: "body",
    environment: environment,
    portalZIndex: portalZIndex,
    resetCSS: resetCSS,
    theme: applyNextTheme(themeWithComponents, next),
    toastOptions: {
      portalProps: {
        containerRef: toastPortalRef
      }
    },
    children: jsxs(Provider$2, {
      value: {
        containerRef: toastTargetRef
      },
      children: [includeFonts && jsx(Fonts, {
        host: fontsHost,
        includeLegacy: includeFonts === 'all' || !next || next !== 'all' && !next.includes('fonts'),
        includeNew: includeFonts === 'all' || next === 'all' || (next === null || next === void 0 ? void 0 : next.includes('fonts'))
      }), next ? jsx(NextFeaturesProvider, {
        value: next,
        children: children
      }) : children]
    })
  });
};

var _excluded$w = ["children", "confirmText", "icon", "onCloseClick", "onConfirmClick", "showClose", "showIcon", "title"];
var iconMap = {
  info: iInfo,
  warning: iAlertCircle,
  error: iAlertCircle,
  success: iCheckCircle,
  // TODO: replace `iLoader` in `@hover/icons` with SVG from `Loader`
  // or just make it available at `hLoader` and switch to that here
  loading: iLoader
};
var colorMap = {
  info: 'primary',
  success: 'success',
  warning: 'warning',
  error: 'danger',
  loading: 'neutral'
};
var Alert = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    confirmText = _ref.confirmText,
    icon = _ref.icon,
    onCloseClick = _ref.onCloseClick,
    onConfirmClick = _ref.onConfirmClick;
    _ref.showClose;
    var _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded$w);
  var styles = useMultiStyleConfig('Alert', _objectSpread2(_objectSpread2({}, props), {}, {
    showIcon: showIcon,
    title: title
  }));
  var _props$status = props.status,
    status = _props$status === void 0 ? 'info' : _props$status;
  var colorScheme = colorMap[status];
  var iconStyles = _objectSpread2(_objectSpread2({}, styles.icon), title ? styles.titleIcon : {});
  // TODO: figure out consistency issue here with `CloseButton` variants
  var closeButtonVariant = status === 'loading' ? 'minimal' : undefined;
  var renderCloseButton = function renderCloseButton() {
    if (!onCloseClick) return null;
    return jsx(CloseButton, {
      colorScheme: colorScheme,
      onClick: onCloseClick,
      size: onConfirmClick || title ? 'large' : undefined,
      variant: closeButtonVariant
    });
  };
  return jsxs(Alert$1, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    ref: ref,
    children: [showIcon && (status === 'loading' ? jsx(Loader, {
      sx: {
        svg: iconStyles
      }
    }) : jsx(Icon, {
      icon: icon !== null && icon !== void 0 ? icon : iconMap[status],
      sx: iconStyles
    })), jsxs(ColorSchemeProvider, {
      colorScheme: colorScheme,
      variant: "dark",
      children: [jsxs(Stack, {
        direction: "column",
        flex: "1",
        spacing: "0",
        children: [title && jsx(AlertTitle, {
          children: title
        }), jsx(AlertDescription, {
          children: children
        })]
      }), onConfirmClick ? jsxs(Stack, {
        alignItems: "center",
        direction: "row",
        spacing: "0",
        sx: styles.confirm,
        children: [jsx(Button, {
          isDisabled: status === 'loading',
          onClick: onConfirmClick,
          sx: styles.confirmButton,
          children: confirmText !== null && confirmText !== void 0 ? confirmText : 'Confirm'
        }), renderCloseButton()]
      }) : renderCloseButton()]
    })]
  }));
});
Alert.displayName = 'Alert';

var useBreakpoint = useBreakpoint$1;
var useBreakpointValue = useBreakpointValue$1;

var useReducedMotionVariants = function useReducedMotionVariants(variants) {
  var isMotionReduced = useIsMotionReduced();
  return stripMotionFromVariants(variants, isMotionReduced !== null && isMotionReduced !== void 0 ? isMotionReduced : false);
};

/**
 * Returns a boolean flag that resets to `false` after the provided timeout
 *
 * @param timeout how long to wait before resetting flag
 */
var useTimeoutFlag = function useTimeoutFlag(timeout) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    flag = _useState2[0],
    setFlag = _useState2[1];
  useEffect(function () {
    if (!flag) return undefined;
    var id = setTimeout(function () {
      return setFlag(false);
    }, timeout);
    return function () {
      return clearTimeout(id);
    };
  }, [flag, timeout]);
  return [flag, setFlag];
};

var _excluded$v = ["children"];
var Panel = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$v);
  return jsx(Box, _objectSpread2(_objectSpread2({
    backgroundColor: "background",
    borderRadius: 300,
    flexDirection: "column",
    padding: 300
  }, props), {}, {
    ref: ref,
    children: children
  }));
});
Panel.displayName = 'Panel';

var _excluded$u = ["as", "children", "element", "isSemiBold", "isBold", "size", "withCapsize"];
var Body = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    element = _ref.element,
    _ref$isSemiBold = _ref.isSemiBold,
    isSemiBold = _ref$isSemiBold === void 0 ? false : _ref$isSemiBold,
    _ref$isBold = _ref.isBold,
    isBold = _ref$isBold === void 0 ? false : _ref$isBold,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 500 : _ref$size,
    _ref$withCapsize = _ref.withCapsize,
    withCapsize = _ref$withCapsize === void 0 ? false : _ref$withCapsize,
    props = _objectWithoutProperties(_ref, _excluded$u);
  var size = mapResponsive(function (s) {
    return "".concat(s);
  }, sizeProp);
  var textStyle = withCapsize ? mapResponsive(function (s) {
    return "body".concat(s, "WithCapsize");
  }, sizeProp) : undefined;
  var getVariant = function getVariant() {
    if (isBold) return 'bold';
    if (isSemiBold) return 'semiBold';
    return 'default';
  };
  return jsx(Text, _objectSpread2(_objectSpread2({
    as: element !== null && element !== void 0 ? element : as,
    textStyle: textStyle
  }, withTestId(props)), {}, {
    ref: ref,
    size: size,
    variant: getVariant(),
    children: children
  }));
});
Body.displayName = 'Body';

var _excluded$t = ["as", "children", "colorScheme", "size", "variant"];
var Code = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.as;
    var children = _ref.children,
    colorScheme = _ref.colorScheme,
    _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? 500 : _ref$size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded$t);
  var _useColorScheme = useColorScheme(),
    contextColorScheme = _useColorScheme.colorScheme,
    contextVariant = _useColorScheme.variant;
  var size = mapResponsive(function (s) {
    return "".concat(s);
  }, sizeProp);
  return jsx(Code$1, _objectSpread2(_objectSpread2({
    colorScheme: colorScheme !== null && colorScheme !== void 0 ? colorScheme : contextColorScheme,
    variant: variant !== null && variant !== void 0 ? variant : contextVariant
  }, withTestId(props)), {}, {
    ref: ref,
    size: size,
    children: children
  }));
});
Code.displayName = 'Code';

var _excluded$s = ["status", "content"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var MotionPanel = /*#__PURE__*/motion(Panel);
var MotionBody = /*#__PURE__*/motion(Body);
var themes = {
  danger: {
    color: 'danger800',
    backgroundColor: 'danger100'
  },
  success: {
    color: 'success800',
    backgroundColor: 'success100'
  },
  warning: {
    color: 'warning800',
    backgroundColor: 'warning100'
  }
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "17lxyek",
  styles: "p{position:absolute;}p:last-of-type{position:static;}"
} : {
  name: "1vxg1wd-Message",
  styles: "p{position:absolute;}p:last-of-type{position:static;};label:Message;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var Message = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'danger' : _ref$status,
    content = _ref.content,
    props = _objectWithoutProperties(_ref, _excluded$s);
  var theme = useTheme();
  return jsx(MotionPanel, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    display: "block"
  }, props), themes[status]), transitions(['background-color', theme.motion.easings[250]])), {}, {
    "aria-live": "assertive",
    css: _ref2,
    layout: true,
    overflow: "hidden",
    position: "relative",
    ref: ref,
    role: "alert",
    children: jsx(AnimatePresence, {
      initial: false,
      children: jsx(MotionBody, {
        animate: {
          opacity: 1,
          y: '0%'
        },
        color: "inherit",
        exit: {
          opacity: 0,
          y: '100%'
        },
        initial: {
          opacity: 0,
          y: '-100%'
        },
        margin: 0,
        size: 400,
        transition: theme.motion.framer.firm,
        children: content
      }, content)
    })
  }));
});

var _createContext$2 = /*#__PURE__*/createContext({
    name: 'CheckboxGroupContext',
    strict: false
  }),
  _createContext2$2 = /*#__PURE__*/_slicedToArray(_createContext$2, 2),
  Provider = _createContext2$2[0],
  useContext = _createContext2$2[1];

/**
 * This is unfortunate, Chakra removed `useCheckboxGroupContext` from the
 * public API in a non-breaking release even though it's technically a breaking
 * change. We need to reimplement it to access the context for custom checkboxes
 * like `CheckButton`.
 */
var CheckboxGroup = function CheckboxGroup(props) {
  var colorScheme = props.colorScheme,
    size = props.size,
    variant = props.variant,
    children = props.children,
    isDisabled = props.isDisabled;
  var _useCheckboxGroup = useCheckboxGroup(props),
    value = _useCheckboxGroup.value,
    onChange = _useCheckboxGroup.onChange;
  var group = useMemo(function () {
    return {
      size: size,
      onChange: onChange,
      colorScheme: colorScheme,
      value: value,
      variant: variant,
      isDisabled: isDisabled
    };
  }, [size, onChange, colorScheme, value, variant, isDisabled]);
  return jsx(Provider, {
    value: group,
    children: jsx(CheckboxGroup$1, _objectSpread2(_objectSpread2({}, props), {}, {
      children: children
    }))
  });
};
CheckboxGroup.displayName = 'CheckboxGroup';

var _excluded$r = ["isDisabled", "onChange", "isMinimal", "name"];
var _createContext$1 = /*#__PURE__*/createContext({
    strict: false
  }),
  _createContext2$1 = /*#__PURE__*/_slicedToArray(_createContext$1, 2),
  ToggleButtonGroupProvider = _createContext2$1[0],
  useToggleButtonGroup = _createContext2$1[1];
var getToggleButtonGroupProps = function getToggleButtonGroupProps(_ref) {
  var _group$name;
  var group = _ref.group,
    props = _ref.props,
    isChecked = _ref.isChecked;
  var isDisabled = props.isDisabled,
    onChange = props.onChange;
    props.isMinimal;
    var name = props.name,
    rest = _objectWithoutProperties(props, _excluded$r);
  return _objectSpread2(_objectSpread2({}, rest), {}, {
    isChecked: isChecked,
    name: group && 'name' in group ? (_group$name = group.name) !== null && _group$name !== void 0 ? _group$name : name : name,
    isDisabled: (group === null || group === void 0 ? void 0 : group.isDisabled) || isDisabled,
    onChange: group !== null && group !== void 0 && group.onChange && props.value != null ? callAll(group.onChange, onChange) : onChange
  });
};
var useToggleButtonProps = function useToggleButtonProps(_ref2) {
  var _useToggleButtonGroup, _ref4, _group$variant, _group$colorScheme, _group$size;
  var props = _ref2.props,
    group = _ref2.group,
    isChecked = _ref2.isChecked;
  var _ref3 = (_useToggleButtonGroup = useToggleButtonGroup()) !== null && _useToggleButtonGroup !== void 0 ? _useToggleButtonGroup : {},
    isMinimalGroup = _ref3.isMinimal;
  var colorScheme = props.colorScheme,
    isMinimal = props.isMinimal;
  var variant = (_ref4 = (_group$variant = group === null || group === void 0 ? void 0 : group.variant) !== null && _group$variant !== void 0 ? _group$variant : props.variant) !== null && _ref4 !== void 0 ? _ref4 : 'tertiary';
  return _objectSpread2({
    colorScheme: (_group$colorScheme = group === null || group === void 0 ? void 0 : group.colorScheme) !== null && _group$colorScheme !== void 0 ? _group$colorScheme : colorScheme,
    fill: isChecked ? 'solid' : 'outline',
    shadow: (isMinimalGroup !== null && isMinimalGroup !== void 0 ? isMinimalGroup : isMinimal) ? 'none !important' : undefined,
    size: (_group$size = group === null || group === void 0 ? void 0 : group.size) !== null && _group$size !== void 0 ? _group$size : props.size,
    variant: mapResponsive(function (v) {
      if (v === 'ghost') {
        return isChecked ? 'tertiary' : 'ghost';
      }
      return isChecked ? v : 'tertiary';
    }, variant)
  }, omit(props, ['defaultChecked', 'id', 'isChecked', 'isFocusable', 'isInvalid', 'isMinimal', 'isReadOnly', 'isRequired', 'name', 'onBlur', 'onChange', 'onFocus', 'tabIndex', 'value', 'variant']));
};

var _excluded$q = ["checkedStrokeWidth", "delay", "indeterminateStrokeWidth", "isChecked", "isDisabled", "isIndeterminate", "isInvalid", "strokeWidth", "variants"];
var DASH_OFFSET_UNCHECKED = '43px';
var DASH_OFFSET_CHECKED = '3px';
var CHECKED_PATH = 'M2 15.556L12 25 30 8';
var INDETERMINATE_PATH = 'M2 16L12 16 30 16';
var getVariant = function getVariant(_ref) {
  var isChecked = _ref.isChecked,
    isIndeterminate = _ref.isIndeterminate;
  if (isIndeterminate) return 'indeterminate';
  if (isChecked) return 'checked';
  return 'unchecked';
};
var Check = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var checkedStrokeWidth = _ref2.checkedStrokeWidth,
    delay = _ref2.delay,
    indeterminateStrokeWidth = _ref2.indeterminateStrokeWidth,
    isChecked = _ref2.isChecked,
    isDisabled = _ref2.isDisabled,
    isIndeterminate = _ref2.isIndeterminate,
    isInvalid = _ref2.isInvalid,
    strokeWidth = _ref2.strokeWidth,
    variants = _ref2.variants,
    props = _objectWithoutProperties(_ref2, _excluded$q);
  var _useTheme = useTheme$1(),
    framer = _useTheme.motion.framer;
  var pathVariants = useMemo(function () {
    var _ref3, _ref4, _ref5;
    return {
      unchecked: {
        strokeDashoffset: DASH_OFFSET_UNCHECKED,
        strokeWidth: (_ref3 = checkedStrokeWidth !== null && checkedStrokeWidth !== void 0 ? checkedStrokeWidth : strokeWidth) !== null && _ref3 !== void 0 ? _ref3 : '6px',
        d: CHECKED_PATH
      },
      checked: {
        strokeDashoffset: DASH_OFFSET_CHECKED,
        strokeWidth: (_ref4 = checkedStrokeWidth !== null && checkedStrokeWidth !== void 0 ? checkedStrokeWidth : strokeWidth) !== null && _ref4 !== void 0 ? _ref4 : '6px',
        d: CHECKED_PATH
      },
      indeterminate: {
        strokeDashoffset: DASH_OFFSET_CHECKED,
        strokeWidth: (_ref5 = indeterminateStrokeWidth !== null && indeterminateStrokeWidth !== void 0 ? indeterminateStrokeWidth : strokeWidth) !== null && _ref5 !== void 0 ? _ref5 : '7px',
        d: INDETERMINATE_PATH
      }
    };
  }, [checkedStrokeWidth, indeterminateStrokeWidth, strokeWidth]);
  return jsx(MotionConfig, {
    transition: _objectSpread2(_objectSpread2({}, framer.firm), {}, {
      delay: isChecked ? delay !== null && delay !== void 0 ? delay : 0 : 0
    }),
    children: jsx(motion$1.svg, _objectSpread2(_objectSpread2({
      variants: variants
    }, props), {}, {
      animate: getVariant({
        isChecked: isChecked,
        isIndeterminate: isIndeterminate
      }),
      custom: {
        isInvalid: isInvalid,
        isDisabled: isDisabled
      },
      ref: ref,
      viewBox: "-4 -4 40 40",
      children: jsx(motion$1.path, {
        strokeDasharray: DASH_OFFSET_UNCHECKED,
        strokeLinejoin: "miter",
        strokeWidth: "3px",
        variants: pathVariants
      })
    }))
  });
});

var _excluded$p = ["children"];
var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _useCheckboxGroupCont;
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var _ref2 = (_useCheckboxGroupCont = useContext()) !== null && _useCheckboxGroupCont !== void 0 ? _useCheckboxGroupCont : {},
    isGroupDisabled = _ref2.isDisabled;
  var isInvalid = props.isInvalid,
    _props$isDisabled = props.isDisabled,
    isDisabled = _props$isDisabled === void 0 ? isGroupDisabled : _props$isDisabled;
  var styles = useMultiStyleConfig('Checkbox', props);
  var isNext = useIsNextFeatureEnabled('components');
  var _useTheme = useTheme(),
    colors = _useTheme.colors;
  var getCheckedBackground = useCallback(function (vp) {
    if (vp.isDisabled) return colors.border.disabled;
    if (vp.isInvalid) return colors.danger.base;
    return isNext ? colors.neutral[900] : colors.primary.base;
  }, [colors, isNext]);
  var backgroundVariants = useMemo(function () {
    return {
      unchecked: function unchecked(vp) {
        return {
          transition: {
            delay: 0.1
          },
          background: vp.isDisabled ? colors.neutral[100] : colors.neutral[0]
        };
      },
      checked: function checked(vp) {
        return {
          background: getCheckedBackground(vp)
        };
      },
      indeterminate: function indeterminate(vp) {
        return {
          background: getCheckedBackground(vp)
        };
      }
    };
  }, [colors, getCheckedBackground]);
  var Icon = useMemo(function () {
    return function (_ref3) {
      var isChecked = _ref3.isChecked,
        isIndeterminate = _ref3.isIndeterminate;
      return jsx(Check, {
        __css: styles.icon,
        delay: 0.06,
        isChecked: isChecked,
        isDisabled: isDisabled,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        variants: backgroundVariants
      });
    };
  }, [styles.icon, isDisabled, isInvalid, backgroundVariants]);
  return jsx(Checkbox$1
  // FIXME: Chakra sets `cursor` internally in a way that's
  // preventing us from controlling it from the theme
  , _objectSpread2(_objectSpread2({
    _disabled: {
      cursor: 'unset'
    },
    cursor: "unset"
  }, props), {}, {
    icon: jsx(Icon, {}, "blueprint-icon"),
    ref: ref,
    children: children
  }));
});
Checkbox.displayName = 'Checkbox';

var _excluded$o = ["defaultValue", "disabled", "isDisabled", "label", "max", "value", "min", "onChange", "snapThreshold", "step", "suggestedValue"];
var Slider = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue;
    _ref.disabled;
    var isDisabled = _ref.isDisabled,
    label = _ref.label,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    value = _ref.value,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    onChange = _ref.onChange,
    snapThreshold = _ref.snapThreshold,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    suggestedValue = _ref.suggestedValue,
    props = _objectWithoutProperties(_ref, _excluded$o);
  var styles = useMultiStyleConfig('Slider', props);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setIsDragging = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isControlPressed = _useState4[0],
    setIsControlPressed = _useState4[1];
  var _useControllableState = useControllableState({
      value: value,
      defaultValue: defaultValue,
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    computedValue = _useControllableState2[0],
    setValue = _useControllableState2[1];
  var onSliderChange = function onSliderChange(updatedValue) {
    if (suggestedValue && snapThreshold && isDragging && !isControlPressed && updatedValue >= suggestedValue - snapThreshold && updatedValue <= suggestedValue + snapThreshold) {
      return setValue(suggestedValue);
    }
    return setValue(updatedValue);
  };
  var onSliderChangeStart = function onSliderChangeStart(event) {
    var _props$onChangeStart;
    (_props$onChangeStart = props.onChangeStart) === null || _props$onChangeStart === void 0 ? void 0 : _props$onChangeStart.call(props, event);
    setIsDragging(true);
  };
  var onSliderChangeEnd = function onSliderChangeEnd(event) {
    var _props$onChangeEnd;
    (_props$onChangeEnd = props.onChangeEnd) === null || _props$onChangeEnd === void 0 ? void 0 : _props$onChangeEnd.call(props, event);
    setIsDragging(false);
  };
  var onWindowKeyDown = function onWindowKeyDown(event) {
    return event.ctrlKey && setIsControlPressed(true);
  };
  var onWindowKeyUp = function onWindowKeyUp(event) {
    return !event.ctrlKey && setIsControlPressed(false);
  };
  useEffect(function () {
    if (isDisabled && suggestedValue && computedValue !== suggestedValue) {
      setValue(suggestedValue);
    }
  }, [computedValue, isDisabled, setValue, suggestedValue]);
  useEffect(function () {
    if (suggestedValue && snapThreshold) {
      window.addEventListener('keydown', onWindowKeyDown);
      window.addEventListener('keyup', onWindowKeyUp);
      return function () {
        window.removeEventListener('keydown', onWindowKeyDown);
        window.removeEventListener('keyup', onWindowKeyUp);
      };
    }
    return undefined;
  }, [snapThreshold, suggestedValue]);
  var isSuggested = suggestedValue ? Math.round(suggestedValue) === Math.round(computedValue) : false;
  return jsxs(Slider$1, _objectSpread2(_objectSpread2({
    "aria-label": label,
    isDisabled: isDisabled,
    max: max,
    min: min,
    onChange: onSliderChange,
    onChangeEnd: onSliderChangeEnd,
    onChangeStart: onSliderChangeStart,
    step: step,
    value: computedValue
  }, props), {}, {
    ref: ref,
    children: [jsx(SliderTrack, {}), suggestedValue && jsx(SliderMark, {
      "data-filled": computedValue >= suggestedValue ? '' : undefined,
      sx: styles.suggestedValueTrack,
      value: suggestedValue
    }), jsx(SliderFilledTrack, {}), suggestedValue && jsx(SliderMark, {
      sx: styles.suggestedValue,
      value: suggestedValue
    }), jsx(SliderThumb, _objectSpread2({
      "data-suggested": isSuggested ? '' : undefined
    }, suggestedValue !== undefined ? {
      'aria-details': "Suggested value ".concat(suggestedValue)
    } : {}))]
  }));
});
Slider.displayName = 'Slider';

var _excluded$n = ["defaultChecked", "defaultValue", "disabled", "error", "isChecked", "isDisabled", "isInvalid", "onValueChange", "size", "value"];
var Toggle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var defaultCheckedProp = _ref.defaultChecked,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    error = _ref.error,
    isCheckedProp = _ref.isChecked,
    isDisabledProp = _ref.isDisabled,
    isInvalidProp = _ref.isInvalid,
    onValueChange = _ref.onValueChange,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    valueProp = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded$n);
  // TODO(1.0): this is pretty gross, but for now we're preserving the original
  // `Toggle` behavior in which `value` and `defaultValue` control what is
  // now `isChecked` and `defaultChecked` respectively.
  var isChecked = isCheckedProp !== null && isCheckedProp !== void 0 ? isCheckedProp : typeof valueProp === 'boolean' ? valueProp : undefined;
  var value = typeof valueProp !== 'boolean' ? valueProp : undefined;
  var defaultChecked = defaultCheckedProp !== null && defaultCheckedProp !== void 0 ? defaultCheckedProp : defaultValue;
  var isDisabled = isDisabledProp !== null && isDisabledProp !== void 0 ? isDisabledProp : disabled;
  var isInvalid = isInvalidProp !== null && isInvalidProp !== void 0 ? isInvalidProp : error;
  var onElementChange = function onElementChange(event) {
    var _props$onChange;
    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(event.target.checked);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, event);
  };
  return jsx(Switch, _objectSpread2(_objectSpread2({
    defaultChecked: defaultChecked,
    isChecked: isChecked,
    isDisabled: isDisabled,
    isInvalid: isInvalid,
    onChange: onElementChange,
    size: size,
    value: value
  }, withTestId(props)), {}, {
    ref: ref
  }));
});
Toggle.displayName = 'Toggle';

var _excluded$m = ["children", "size", "iconSize"];
var iconSizeFor = function iconSizeFor(size) {
  switch (size) {
    case 'default':
      return size100;
    case 'small':
      return size75;
    case 'tiny':
      return size50;
    default:
      return null;
  }
};
var Select = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _iconSizeFor;
  var children = _ref.children,
    size = _ref.size,
    iconSize = _ref.iconSize,
    props = _objectWithoutProperties(_ref, _excluded$m);
  return jsx(Select$1, _objectSpread2(_objectSpread2({
    icon: jsx(Icon, {
      icon: iChevronDown
    }),
    iconSize: (_iconSizeFor = iconSizeFor(size)) !== null && _iconSizeFor !== void 0 ? _iconSizeFor : iconSize,
    noOfLines: 1,
    size: size
  }, props), {}, {
    ref: ref,
    children: children
  }));
});
Select.displayName = 'Select';

var TextInputType = {
  text: 'text',
  search: 'search',
  tel: 'tel',
  url: 'url',
  email: 'email',
  number: 'number',
  password: 'password',
  date: 'date',
  time: 'time',
  dateTime: 'datetime-local',
  month: 'month'
};
var TextInputMode = {
  text: 'text',
  search: 'search',
  tel: 'tel',
  url: 'url',
  email: 'email',
  numeric: 'numeric',
  decimal: 'decimal',
  none: 'none'
};

/* eslint-disable @typescript-eslint/no-redeclare */

var _excluded$l = ["iconAfter", "iconBefore", "elementAfter", "elementBefore", "isDisabled", "isInvalid", "label", "onBlur", "onFocus", "mode", "type", "testId"];
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var iconAfter = _ref.iconAfter,
    iconBefore = _ref.iconBefore,
    elementAfter = _ref.elementAfter,
    elementBefore = _ref.elementBefore,
    isDisabled = _ref.isDisabled,
    isInvalid = _ref.isInvalid,
    label = _ref.label,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? TextInputMode.text : _ref$mode,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? TextInputType.text : _ref$type,
    testId = _ref.testId,
    props = _objectWithoutProperties(_ref, _excluded$l);
  var _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size;
  var _splitLayoutProps = splitLayoutProps(props),
    layoutProps = _splitLayoutProps.layoutProps,
    inputProps = _splitLayoutProps.props;
  var t = pickThemingProps(props);
  var inputGroupProps = _objectSpread2(_objectSpread2({}, layoutProps), t);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    focused = _useState2[0],
    setFocused = _useState2[1];
  var onElementFocus = function onElementFocus(event) {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
  };
  var onElementBlur = function onElementBlur(event) {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
  };
  var onElementChange = function onElementChange(event) {
    var _props$onChange;
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, event);
  };
  var renderElement = useCallback(function (position, icon, element) {
    var Element = position === 'before' ? InputLeftElement : InputRightElement;
    if (element) return jsx(Element, {
      children: element
    });
    if (!icon) return null;
    var color = focused ? 'primary.900' : 'neutral.500';
    var errorColor = focused ? 'danger.700' : 'danger.500';
    return jsx(Element, {
      children: jsx(Icon, {
        color: isInvalid ? errorColor : color,
        icon: icon,
        margin: 0,
        size: size === 'tiny' ? 'tiny' : 'small'
      })
    });
  }, [focused, isInvalid, size]);
  return jsxs(InputGroup, _objectSpread2(_objectSpread2({}, withTestId(_objectSpread2(_objectSpread2({}, inputGroupProps), {}, {
    testId: testId
  }))), {}, {
    children: [renderElement('before', iconBefore, elementBefore), jsx(Input, _objectSpread2({
      "aria-label": label,
      inputMode: mode,
      isDisabled: isDisabled,
      isInvalid: isInvalid,
      onBlur: onElementBlur,
      onChange: onElementChange,
      onFocus: onElementFocus,
      ref: ref,
      type: type
    }, inputProps)), renderElement('after', iconAfter, elementAfter)]
  }));
});
TextInput.displayName = 'TextInput';

/**
 * All layout primitives
 */
var layoutElements = [AspectRatio, Box, Center, Box$1, Container, Flex, Grid, HStack, SimpleGrid, Spacer, Stack, VStack, Wrap];
var isIntrinsicElement = function isIntrinsicElement(element) {
  if (typeof element === 'string' || typeof element === 'number' || typeof element.type === 'string') return true;
  return false;
};
/**
 * Check if a child element is a layout element (`Box`, `Stack`, etc.)
 *
 * @param element child JSX node
 */
var isLayoutElement = function isLayoutElement(element) {
  if (! /*#__PURE__*/isValidElement(element)) return false;
  if (isIntrinsicElement(element)) return false;
  return includes(layoutElements, element.type);
};

/**
 * Subset of inputs that support an `isInvalid` state
 */
var invalidatableInputElements = [Checkbox, Input, NumberInput, PinInput, Radio, Select, Switch, TextInput, Textarea, Toggle];

/**
 * Subset of inputs that already include a `<label />`
 */
var labeledInputElements = [CheckboxGroup, RadioGroup, Checkbox];
var inputElements = /*#__PURE__*/[].concat(invalidatableInputElements, labeledInputElements, [Slider]);
/**
 * Check if a child element is an input
 *
 * @param element child JSX node
 */
var isInputElement = function isInputElement(element) {
  if (! /*#__PURE__*/isValidElement(element)) return false;
  if (isIntrinsicElement(element)) return false;
  return includes(inputElements, element.type);
};
var isInvalidatableInputElement = function isInvalidatableInputElement(element) {
  if (!isInputElement(element)) return false;
  return includes(invalidatableInputElements, element.type);
};

/**
 * Check if a child element is an input element that includes a `<label />`
 *
 * @param element child JSX node
 */
var isLabeledInputElement = function isLabeledInputElement(element) {
  if (!isInputElement(element)) return false;
  return includes(labeledInputElements, element.type);
};

var MotionDiv = /*#__PURE__*/motion(chakra.div);
var FormErrorMessage = /*#__PURE__*/forwardRef(function (props, ref) {
  var styles = useMultiStyleConfig('FormError', props);
  var ownProps = omitThemingProps(props);
  var field = useFormControlContext();
  var variants = useReducedMotionVariants({
    valid: {
      opacity: 0,
      transform: 'translate3d(0, -100%, 0)'
    },
    invalid: {
      opacity: 1,
      transform: 'translate3d(0, 0%, 0)'
    }
  });
  return jsx(StylesProvider, {
    value: styles,
    children: jsx(AnimatePresence, {
      children: (field === null || field === void 0 ? void 0 : field.isInvalid) &&
      // @ts-expect-error
      jsx(MotionDiv, _objectSpread2(_objectSpread2({}, field === null || field === void 0 ? void 0 : field.getErrorMessageProps(ownProps, ref)), {}, {
        __css: _objectSpread2({
          display: 'flex',
          alignItems: 'center'
        }, styles.text),
        animate: "invalid",
        className: ['chakra-form__error-message', props.className].filter(isDefined).join(' '),
        exit: "valid",
        initial: "valid",
        role: "alert",
        variants: variants
      }))
    })
  });
});
FormErrorMessage.displayName = 'FormErrorMessage';

var _excluded$k = ["children", "error", "isDisabled", "label", "name", "note", "requiredLabel"];
var spacingError = 100;
var spacingBottom = 200;
var paddingBottomInvalid = /*#__PURE__*/math( /*#__PURE__*/"".concat(space[spacingError], " + ").concat(textSizes[400].lineHeight, " + ").concat(space[spacingBottom]));
var MotionFormControl = /*#__PURE__*/motion(FormControl);
var invalidVariants = {
  valid: {
    paddingBottom: space[500]
  },
  invalid: {
    paddingBottom: paddingBottomInvalid
  }
};
var Field = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    error = _ref.error,
    isDisabled = _ref.isDisabled,
    label = _ref.label,
    name = _ref.name,
    note = _ref.note,
    _ref$requiredLabel = _ref.requiredLabel,
    requiredLabel = _ref$requiredLabel === void 0 ? 'Required' : _ref$requiredLabel,
    props = _objectWithoutProperties(_ref, _excluded$k);
  var child = Children.only(children);
  var isInvalid = !!error;
  var shouldDefaultPlaceholder = includes([TextInput, Input], child.type);
  var isLabeled = isLabeledInputElement(child);
  var supportsIsDisabled = isInputElement(child);
  var supportsIsInvalid = isInvalidatableInputElement(child);
  var isMotionReduced = useIsMotionReduced();
  var inputProps = _objectSpread2(_objectSpread2(_objectSpread2({}, supportsIsDisabled ? {
    isDisabled: isDisabled
  } : {}), supportsIsInvalid ? {
    isInvalid: isInvalid
  } : {}), {}, {
    name: name,
    placeholder: shouldDefaultPlaceholder ? label : undefined
  }, child.props);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  useEffect(function () {
    if (error) setErrorMessage(error);
  }, [error]);
  var requiredColor = isInvalid ? {
    color: 'danger.500'
  } : {};
  return jsx(MotionConfig, {
    transition: isMotionReduced ? {
      duration: 0
    } : motion$2.framer.tight,
    children: jsxs(MotionFormControl, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
      animate: isInvalid ? 'invalid' : 'valid',
      as: isLabeled && label ? 'fieldset' : 'div',
      initial: false,
      isInvalid: isInvalid,
      ref: ref,
      variants: invalidVariants,
      children: [label && jsx(FormLabel, {
        as: isLabeled ? 'legend' : 'label',
        requiredIndicator: jsx(RequiredIndicator, {
          sx: requiredColor,
          children: requiredLabel
        }),
        sx: requiredColor,
        children: label
      }), jsx(FormErrorMessage, {
        bottom: spacingBottom,
        position: "absolute",
        children: errorMessage
      }), /*#__PURE__*/cloneElement(child, inputProps), note && jsx(FormHelperText, {
        children: note
      })]
    }))
  });
});
Field.displayName = 'Field';

var _excluded$j = ["gap", "icon", "size", "onPointerDown", "onPointerUp"],
  _excluded2$3 = ["max", "min", "onChange", "onInvalid", "step", "value"];
var iconSizes = {
  tiny: 'tiny',
  small: 'small',
  "default": 'small'
};
var StepperButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _after;
  _ref.gap;
    var icon = _ref.icon,
    size = _ref.size,
    onPointerDown = _ref.onPointerDown,
    onPointerUp = _ref.onPointerUp,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var disabled = props.disabled;
  var _useTheme = useTheme$1(),
    colors = _useTheme.colors;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDown = _useState2[0],
    setIsDown = _useState2[1];
  var onButtonDown = function onButtonDown(event) {
    setIsDown(true);
    onPointerDown === null || onPointerDown === void 0 ? void 0 : onPointerDown(event);
  };
  var onButtonUp = function onButtonUp(event) {
    setIsDown(false);
    onPointerUp === null || onPointerUp === void 0 ? void 0 : onPointerUp(event);
  };
  return (
    // TODO: move this styling to the theme
    jsx(chakra.button, _objectSpread2(_objectSpread2(_objectSpread2({
      background: "transparent",
      border: "none",
      borderRadius: "300",
      color: disabled ? 'neutral.400' : 'neutral.600',
      cursor: disabled ? 'default' : 'pointer',
      margin: "50",
      onPointerDown: onButtonDown,
      onPointerUp: onButtonUp,
      padding: "0",
      ref: ref,
      sx: {
        ':hover:not([disabled])': {
          background: isDown ? lighten(0.075, colors.primary[200]) : 'primary.100',
          color: isDown ? 'brandNavy.800' : 'brandNavy.500'
        },
        _after: (_after = {
          borderColor: 'neutral.200',
          borderStyle: 'solid',
          borderWidth: 0,
          borderRightWidth: '400',
          content: '""',
          position: 'absolute'
        }, _defineProperty(_after, icon === iPlus ? 'left' : 'right', 0), _defineProperty(_after, "top", '17.5%'), _defineProperty(_after, "bottom", '17.5%'), _after)
      },
      type: "button"
    }, transitions(['background', 'color'], motion$2.easings[150])), props), {}, {
      children: jsx(Icon, {
        icon: icon,
        isStatic: true,
        size: size
      })
    }))
  );
});
var StepperInput = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var max = _ref2.max,
    min = _ref2.min,
    onChange = _ref2.onChange,
    onInvalid = _ref2.onInvalid,
    step = _ref2.step,
    value = _ref2.value,
    props = _objectWithoutProperties(_ref2, _excluded2$3);
  var _useNumberInput = useNumberInput(_objectSpread2({
      step: step,
      min: min,
      max: max,
      onChange: onChange,
      onInvalid: onInvalid,
      value: value
    }, props)),
    getInputProps = _useNumberInput.getInputProps,
    getIncrementButtonProps = _useNumberInput.getIncrementButtonProps,
    getDecrementButtonProps = _useNumberInput.getDecrementButtonProps;
  var _props$size = props.size,
    size = _props$size === void 0 ? 'default' : _props$size;
  var _splitLayoutProps = splitLayoutProps(props),
    layoutProps = _splitLayoutProps.layoutProps,
    inputProps = _splitLayoutProps.props;
  var inputGroupProps = _objectSpread2(_objectSpread2({}, layoutProps), pickThemingProps(props));
  var buttonSize = mapResponsive(function (s) {
    return iconSizes[s];
  }, size, 'small');
  var buttonPadding = mapResponsive(function (s) {
    return s === 'default' ? '100' : '0';
  }, size, '0');
  return jsxs(InputGroup, _objectSpread2(_objectSpread2({}, inputGroupProps), {}, {
    children: [jsx(InputLeftElement, {
      children: jsx(StepperButton, _objectSpread2(_objectSpread2({}, getDecrementButtonProps()), {}, {
        "aria-label": "Subtract ".concat(step !== null && step !== void 0 ? step : '1'),
        "data-test-id": "stepper-styled-subtract-button",
        icon: iMinus,
        padding: buttonPadding,
        size: buttonSize
      }))
    }), jsx(Input, _objectSpread2(_objectSpread2(_objectSpread2({
      inputMode: "decimal",
      textAlign: "center",
      type: "number"
    }, getInputProps()), inputProps), {}, {
      ref: ref
    })), jsx(InputRightElement, {
      children: jsx(StepperButton, _objectSpread2(_objectSpread2({}, getIncrementButtonProps()), {}, {
        "aria-label": "Add ".concat(step !== null && step !== void 0 ? step : '1'),
        "data-test-id": "stepper-styled-add-button",
        icon: iPlus,
        padding: buttonPadding,
        size: buttonSize
      }))
    })]
  }));
});
StepperInput.displayName = 'StepperInput';

var _excluded$i = ["children", "description", "isSubtle", "noOfLines"];
var createControl = function createControl(Control) {
  return forwardRef(function (_ref, ref) {
    var children = _ref.children,
      description = _ref.description,
      isSubtle = _ref.isSubtle,
      noOfLines = _ref.noOfLines,
      props = _objectWithoutProperties(_ref, _excluded$i);
    var styles = useMultiStyleConfig('TileControl', props);
    return jsxs(Control, _objectSpread2(_objectSpread2({}, props), {}, {
      cursor: props.isDisabled ? 'default' : 'pointer',
      "data-group": true,
      display: "grid",
      ref: ref,
      variant: isSubtle ? 'subtle-tile' : 'tile',
      children: [jsx(chakra.span, {
        noOfLines: noOfLines,
        sx: styles.label,
        children: children
      }), description && jsx(Body, {
        as: "span",
        noOfLines: noOfLines,
        size: 500,
        sx: styles.description,
        children: description
      })]
    }));
  });
};
var TileCheckbox = /*#__PURE__*/createControl(Checkbox);
var TileRadio = /*#__PURE__*/createControl(Radio);

Editable.displayName = 'Editable';
EditableInput.displayName = 'EditableInput';
EditableTextarea.displayName = 'EditableTextarea';
EditablePreview.displayName = 'EditablePreview';

var _excluded$h = ["sx"];
var TabHeading = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var _useMultiStyleConfig = useMultiStyleConfig('Tabs', props),
    heading = _useMultiStyleConfig.heading;
  return jsx(chakra.h2, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, heading), sx)
  }));
});
TabHeading.displayName = 'TabHeading';

Tabs.displayName = 'Tabs';
TabList.displayName = 'TabList';
TabPanels.displayName = 'TabPanels';
Tab.displayName = 'Tab';
TabPanel.displayName = 'TabPanel';

var MenuButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var menuButtonProps = useMenuButton(props, ref);
  return jsx(Button, _objectSpread2(_objectSpread2({
    iconAfter: iChevronDown,
    paddingX: 300,
    shape: "box"
  }, props), menuButtonProps));
});
MenuButton.displayName = 'MenuButton';

var _excluded$g = ["children", "hasArrow", "inPortal", "sx", "trigger"];
/**
 * Checks whether the `trigger` component is a `MenuButton`, otherwise add the
 * `as={MenuButton}` prop to the custom trigger component so that it works
 * properly with `Menu`
 *
 * @param trigger trigger component
 */
var getTrigger = function getTrigger(trigger) {
  // If we had some way to actually verify the passed `trigger` supports the
  // `as` prop, we'd wanna do that here too, but unfortunately this is all we
  // can guard against
  !!isIntrinsicElement(trigger) ? process.env.NODE_ENV !== "production" ? invariant(false, componentMessage('Menu', '`trigger` element must be a system component (it must support the `as` prop)')) : invariant(false) : void 0;
  if (trigger.type === MenuButton) return trigger;
  return /*#__PURE__*/cloneElement(trigger, _objectSpread2(_objectSpread2({}, trigger.props), {}, {
    as: MenuButton$1
  }));
};
var Menu = function Menu(_ref) {
  var children = _ref.children,
    hasArrow = _ref.hasArrow,
    inPortal = _ref.inPortal,
    sx = _ref.sx,
    trigger = _ref.trigger,
    props = _objectWithoutProperties(_ref, _excluded$g);
  var _useTheme = useTheme(),
    colors = _useTheme.colors;
  var nextRootClassName = useNextThemeRootClassName();
  var arrowStyles = hasArrow ? {
    // TODO: move these to the theme
    '--popper-arrow-bg': colors.neutral[0],
    '--popper-arrow-shadow-color': colors.darkAlpha[200],
    minWidth: 'unset'
  } : {};
  var _splitSystemProps = splitSystemProps(props),
    menuProps = _splitSystemProps.props,
    systemProps = _splitSystemProps.systemProps;
  var list = function list(renderPropProps) {
    return jsxs(MenuList, _objectSpread2(_objectSpread2({
      className: inPortal ? nextRootClassName : undefined
    }, systemProps), {}, {
      sx: _objectSpread2(_objectSpread2({}, arrowStyles), sx),
      children: [hasArrow && jsx(chakra.div, {
        clipPath: "polygon(50% -50%, 150% 55%, -50% 55%)",
        "data-popper-arrow": true,
        zIndex: "1 !important",
        children: jsx(chakra.div, {
          "data-popper-arrow-inner": true
        })
      }), invoke(children, renderPropProps)]
    }));
  };
  return jsx(Menu$1, _objectSpread2(_objectSpread2({}, menuProps), {}, {
    children: function children(renderPropProps) {
      return jsxs(Fragment, {
        children: [getTrigger(invoke(trigger, renderPropProps)), inPortal ? jsx(Portal, {
          children: list(renderPropProps)
        }) : list(renderPropProps)]
      });
    }
  }));
};
Menu.displayName = 'Menu';

var _excluded$f = ["checkColor", "sx"];
var MenuItemOption = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var checkColor = _ref.checkColor,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var isChecked = props.isChecked,
    isDisabled = props.isDisabled;
  var wrapperStylesChecked = {
    opacity: '1 !important'
  };
  var wrapperStylesUnchecked = {
    transitionProperty: 'opacity',
    transitionDuration: '0.15s',
    transitionTimingFunction: 'ease-in'
  };
  return jsx(MenuItemOption$1, _objectSpread2(_objectSpread2({
    sx: _objectSpread2(_objectSpread2({}, sx), {}, {
      '& .chakra-menu__icon-wrapper': _objectSpread2({
        height: 100
      }, isChecked ? wrapperStylesChecked : wrapperStylesUnchecked)
    })
  }, props), {}, {
    icon: jsx(Check, {
      isChecked: isChecked,
      isDisabled: isDisabled,
      sx: {
        fill: 'none',
        stroke: checkColor !== null && checkColor !== void 0 ? checkColor : 'neutral.600'
      },
      width: "100"
    }),
    ref: ref
  }));
});
MenuItemOption.id = 'MenuItemOption';

MenuCommand.displayName = 'MenuCommand';
MenuDivider.displayName = 'MenuDivider';
MenuGroup.displayName = 'MenuGroup';
MenuIcon.displayName = 'MenuIcon';
MenuItem.displayName = 'MenuItem';
MenuOptionGroup.displayName = 'MenuOptionGroup';

var CloseIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(Icon$1, _objectSpread2(_objectSpread2({
    "aria-hidden": true,
    focusable: "false",
    viewBox: "0 0 14 14"
  }, props), {}, {
    ref: ref,
    children: jsx("path", {
      d: "m.75.5 6.375 6.375M13.5 13.25 7.125 6.875M13.5.5 7.125 6.875M.75 13.25l6.375-6.375",
      stroke: "currentColor"
    })
  }));
});

var ModalCloseButton = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(ModalCloseButton$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: jsx(CloseIcon, {})
  }));
});

var renderFooter = function renderFooter(footer) {
  if (isLayoutElement(footer)) {
    return /*#__PURE__*/cloneElement(footer, _objectSpread2(_objectSpread2({}, footer.props), {}, {
      as: ModalFooter
    }));
  }

  // NOTE: for some reason a fragment is required to render a text child here
  // TODO(1.0): consider narrowing type to alleviate this as I'm not sure it
  // makes sense to support text-only content in the footer
  // eslint-disable-next-line react/jsx-no-useless-fragment
  var content = typeof footer === 'string' ? jsx(Fragment, {
    children: footer
  }) : footer;
  return jsx(HStack, {
    as: ModalFooter,
    spacing: "400",
    children: content
  });
};
var OverlayContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bodyProps = _ref.bodyProps,
    className = _ref.className,
    children = _ref.children,
    Content = _ref.component,
    contentProps = _ref.contentProps,
    footer = _ref.footer,
    header = _ref.header,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
    _ref$isOverlay = _ref.isOverlay,
    isOverlay = _ref$isOverlay === void 0 ? true : _ref$isOverlay,
    maxContentHeight = _ref.maxContentHeight;
  return jsxs(Fragment, {
    children: [isOverlay && jsx(ModalOverlay, {}), jsxs(Content, _objectSpread2(_objectSpread2({
      className: cx(className, useNextThemeRootClassName())
    }, contentProps), {}, {
      ref: ref,
      children: [header && jsx(ModalHeader, {
        children: header
      }), jsx(ModalBody, _objectSpread2(_objectSpread2({
        maxHeight: maxContentHeight
      }, bodyProps), {}, {
        children: children
      })), footer && renderFooter(footer), isClosable && jsx(ModalCloseButton, {
        variant: "minimal"
      })]
    }))]
  });
});
OverlayContent.displayName = 'OverlayContent';

var _excluded$e = ["bodyProps", "cancelProps", "cancelText", "children", "closeOnConfirm", "confirmProps", "confirmText", "contentProps", "header", "isClosable", "isDestructive", "maxContentHeight", "onCancelClick", "onConfirmClick"];
var Dialog = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bodyProps = _ref.bodyProps,
    cancelProps = _ref.cancelProps,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
    children = _ref.children,
    _ref$closeOnConfirm = _ref.closeOnConfirm,
    closeOnConfirm = _ref$closeOnConfirm === void 0 ? true : _ref$closeOnConfirm,
    confirmProps = _ref.confirmProps,
    _ref$confirmText = _ref.confirmText,
    confirmText = _ref$confirmText === void 0 ? 'Okay' : _ref$confirmText,
    contentProps = _ref.contentProps,
    header = _ref.header,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
    _ref$isDestructive = _ref.isDestructive,
    isDestructive = _ref$isDestructive === void 0 ? false : _ref$isDestructive,
    maxContentHeight = _ref.maxContentHeight,
    onCancelClick = _ref.onCancelClick,
    onConfirmClick = _ref.onConfirmClick,
    props = _objectWithoutProperties(_ref, _excluded$e);
  var leastDestructiveRef = useRef(null);
  var onConfirmation = function onConfirmation(event) {
    if (closeOnConfirm) props.onClose();
    onConfirmClick(event);
  };
  var footer = jsxs(Stack, {
    alignItems: {
      base: 'stretch',
      tablet: 'end'
    },
    direction: {
      base: 'column',
      tablet: 'row'
    },
    spacing: "400",
    children: [jsx(Button, _objectSpread2(_objectSpread2({
      fill: "outline",
      onClick: onCancelClick || props.onClose,
      size: "large"
    }, cancelProps), {}, {
      children: cancelText
    })), jsx(Button, _objectSpread2(_objectSpread2({
      color: isDestructive ? 'danger' : 'primary',
      fill: "solid",
      onClick: onConfirmation,
      size: "large"
    }, confirmProps), {}, {
      children: confirmText
    }))]
  });
  return jsx(AlertDialog, _objectSpread2(_objectSpread2({}, props), {}, {
    leastDestructiveRef: leastDestructiveRef,
    children: jsx(OverlayContent, {
      bodyProps: bodyProps,
      component: AlertDialogContent,
      contentProps: contentProps,
      footer: footer,
      header: header,
      isClosable: isClosable,
      maxContentHeight: maxContentHeight,
      ref: ref,
      children: children
    })
  }));
});
Dialog.displayName = 'Dialog';

var _excluded$d = ["bodyProps", "contentProps", "children", "header", "footer", "isClosable", "isOverlay"];
var Drawer = function Drawer(_ref) {
  var bodyProps = _ref.bodyProps,
    contentProps = _ref.contentProps,
    children = _ref.children,
    header = _ref.header,
    footer = _ref.footer,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
    _ref$isOverlay = _ref.isOverlay,
    isOverlay = _ref$isOverlay === void 0 ? true : _ref$isOverlay,
    props = _objectWithoutProperties(_ref, _excluded$d);
  var isOverlayProps = isOverlay ? {} : {
    closeOnOverlayClick: false,
    trapFocus: false,
    variant: 'persistent'
  };
  return jsx(Drawer$1, _objectSpread2(_objectSpread2(_objectSpread2({}, isOverlayProps), props), {}, {
    children: jsx(OverlayContent, {
      bodyProps: bodyProps,
      component: DrawerContent,
      contentProps: contentProps,
      footer: footer,
      header: header,
      isClosable: isClosable,
      isOverlay: isOverlay,
      children: children
    })
  }));
};
Drawer.displayName = 'Drawer';

var _excluded$c = ["colorScheme", "defaultValue", "filters", "label", "onChange", "renderCount", "triggerProps", "type", "value"];
var FilterMenu = function FilterMenu(_ref) {
  var _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === void 0 ? 'primary' : _ref$colorScheme,
    defaultValue = _ref.defaultValue,
    filters = _ref.filters,
    label = _ref.label,
    onChange = _ref.onChange,
    renderCount = _ref.renderCount,
    triggerProps = _ref.triggerProps,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'checkbox' : _ref$type,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded$c);
  var _useControllableState = useControllableState({
      value: value,
      defaultValue: defaultValue,
      onChange: onChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    internalValue = _useControllableState2[0],
    setInternalValue = _useControllableState2[1];
  var count = Array.isArray(internalValue) ? internalValue.length : 1;
  var onMenuOptionGroupChange = function onMenuOptionGroupChange(newValue) {
    return setInternalValue(newValue);
  };
  return jsx(Menu, _objectSpread2(_objectSpread2({
    closeOnSelect: false
  }, props), {}, {
    trigger: jsxs(Button, _objectSpread2(_objectSpread2({
      color: colorScheme,
      "data-group": true,
      fill: "outline",
      iconBefore: iFilter,
      label: filters.map(function (filter) {
        return filter.label;
      }).join(','),
      px: 200,
      shape: "box"
    }, triggerProps), {}, {
      children: [jsx("span", {
        children: label
      }), renderCount ? renderCount(count) : jsx(Code, _objectSpread2(_objectSpread2({
        _groupHover: {
          bg: "".concat(colorScheme, ".200")
        },
        borderRadius: "200",
        colorScheme: colorScheme,
        ml: 200,
        size: 300
      }, transitions(['background'], motion$2.easings[250])), {}, {
        children: count.toString()
      }))]
    })),
    children: jsx(MenuOptionGroup, {
      onChange: onMenuOptionGroupChange,
      type: type,
      value: internalValue,
      children: filters.map(function (filter) {
        return jsx(MenuItemOption, {
          value: filter.value,
          children: filter.label
        }, filter.value);
      })
    })
  }));
};

var _excluded$b = ["children", "color", "isAnimated", "isCaptioned", "speed", "isLoading", "label"];
var presence = {
  animate: 'loading',
  exit: 'hidden',
  initial: 'hidden'
};
var MotionHeading = /*#__PURE__*/motion$1(Heading);
var MotionLoader = /*#__PURE__*/motion$1(Loader);
var MotionCenter$1 = /*#__PURE__*/motion$1(Center);
var LoadingOverlay = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.children;
    var color = _ref.color,
    _ref$isAnimated = _ref.isAnimated,
    isAnimatedProp = _ref$isAnimated === void 0 ? true : _ref$isAnimated,
    _ref$isCaptioned = _ref.isCaptioned,
    isCaptioned = _ref$isCaptioned === void 0 ? false : _ref$isCaptioned,
    speed = _ref.speed,
    isLoading = _ref.isLoading,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var isMotionReduced = useIsMotionReduced();
  var isAnimated = !isMotionReduced && isAnimatedProp;
  var overlayVariants = {
    loading: {
      opacity: 1
    },
    hidden: {
      opacity: 0
    }
  };
  var loaderVariants = stripMotionFromVariants({
    loading: {
      opacity: 1,
      y: '0%'
    },
    hidden: {
      opacity: 0,
      y: '50%'
    }
  }, !isAnimated);
  return jsx(Portal, _objectSpread2(_objectSpread2({}, props), {}, {
    children: jsx(Box, {
      className: useNextThemeRootClassName(),
      position: "fixed",
      top: "0",
      zIndex: "loading",
      children: jsx(Motion.Firm, {
        children: jsx(AnimatePresence, {
          children: isLoading && jsx(MotionCenter$1, _objectSpread2(_objectSpread2({
            background: "overlayLight",
            height: "100vh",
            ref: ref,
            variants: overlayVariants,
            width: "100vw"
          }, presence), {}, {
            children: jsx(RemoveScroll, {
              children: jsxs(VStack, {
                spacing: "100",
                children: [jsx(MotionLoader, _objectSpread2({
                  color: color,
                  label: label,
                  size: "huge",
                  speed: speed,
                  variants: loaderVariants
                }, presence)), isCaptioned && jsx(MotionHeading, _objectSpread2(_objectSpread2({
                  variants: overlayVariants
                }, presence), {}, {
                  bg: "lightAlpha.800",
                  color: "darkAlpha.800",
                  isLight: true,
                  px: "200",
                  rounded: "300",
                  size: 200,
                  children: label
                }))]
              })
            })
          }))
        })
      })
    })
  }));
});
LoadingOverlay.displayName = 'LoadingOverlay';

var _excluded$a = ["children", "color", "delay", "isLoading", "label", "speed", "size"];
var MotionCenter = /*#__PURE__*/motion$1(Center);
var LoadingState = /*#__PURE__*/forwardRef(function (_ref, ref) {
  _ref.children;
    var color = _ref.color,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? 0 : _ref$delay,
    isLoadingProp = _ref.isLoading,
    label = _ref.label,
    speed = _ref.speed,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded$a);
  var _useState = useState(!!isLoadingProp),
    _useState2 = _slicedToArray(_useState, 2),
    isLoadingWithDelay = _useState2[0],
    setIsLoadingWithDelay = _useState2[1];
  useEffect(function () {
    var timeout = null;
    if (isLoadingProp && delay) {
      timeout = window.setTimeout(function () {
        return setIsLoadingWithDelay(true);
      }, delay);
    }
    if (!isLoadingProp) setIsLoadingWithDelay(false);
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, [delay, isLoadingProp]);
  var isLoading = delay ? isLoadingWithDelay : isLoadingProp;
  return jsx(Motion.Firm, {
    children: jsx(AnimatePresence, {
      children: isLoading && jsx(MotionCenter, _objectSpread2(_objectSpread2({
        animate: {
          opacity: 1
        },
        background: "overlayLight",
        bottom: "0",
        exit: {
          opacity: 0
        },
        initial: {
          opacity: 0
        },
        left: "0",
        margin: "0 !important",
        position: "absolute",
        ref: ref,
        right: "0",
        rounded: "inherit",
        top: "0",
        zIndex: 10
      }, props), {}, {
        children: jsx(Loader, {
          color: color,
          label: label,
          size: size,
          speed: speed
        })
      }))
    })
  });
});
LoadingState.displayName = 'LoadingState';

var _excluded$9 = ["bodyProps", "contentProps", "children", "header", "footer", "isClosable", "maxContentHeight"];
var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bodyProps = _ref.bodyProps,
    contentProps = _ref.contentProps,
    children = _ref.children,
    header = _ref.header,
    footer = _ref.footer,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? true : _ref$isClosable,
    maxContentHeight = _ref.maxContentHeight,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return jsx(Modal$1, _objectSpread2(_objectSpread2({}, props), {}, {
    children: jsx(OverlayContent, {
      bodyProps: bodyProps,
      component: ModalContent,
      contentProps: contentProps,
      footer: footer,
      header: header,
      isClosable: isClosable,
      maxContentHeight: maxContentHeight,
      ref: ref,
      children: children
    })
  }));
});
Modal.displayName = 'Modal';

var _excluded$8 = ["className", "motionParameters"];
var MotionSection = /*#__PURE__*/motion$1(chakra.section);
var SheetDialog = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    motionParameters = _ref.motionParameters,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var _useTheme = useTheme(),
    spring = _useTheme.motion.framer;
  var variants = useMemo(function () {
    var initial = props.drag === 'x' ? {
      x: '100%',
      y: '0%'
    } : {
      y: '100%',
      x: '0%'
    };
    return {
      initial: initial,
      enter: {
        x: '0%',
        y: '0%',
        transition: spring.firm
      },
      exit: function exit(_ref2) {
        var forceRef = _ref2.forceRef;
        var force = forceRef.current;
        var transition = force ? _objectSpread2(_objectSpread2({}, props.transition), {}, {
          duration: transform(force, [0, 200000], [1, 0.4])
        }) : props.transition;
        return _objectSpread2(_objectSpread2({}, initial), {}, {
          transition: transition
        });
      }
    };
  }, [props.drag, props.transition, spring.firm]);
  return jsx(MotionSection, _objectSpread2(_objectSpread2({
    animate: "enter",
    className: cx('hover-sheet', className),
    custom: motionParameters,
    exit: "exit",
    initial: "initial",
    variants: variants
  }, props), {}, {
    ref: ref
  }));
});

var _excluded$7 = ["axis"],
  _excluded2$2 = ["className", "children", "containerProps"];
var inertiaTransition = {
  type: 'inertia',
  bounceStiffness: 300,
  bounceDamping: 40,
  timeConstant: 300,
  min: 0,
  max: 0
};
var SheetContent = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var axis = _ref.axis,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var className = props.className,
    children = props.children,
    rootProps = props.containerProps,
    rest = _objectWithoutProperties(props, _excluded2$2);
  var _useModalContext = useModalContext(),
    getDialogProps = _useModalContext.getDialogProps,
    getDialogContainerProps = _useModalContext.getDialogContainerProps,
    onClose = _useModalContext.onClose,
    isOpen = _useModalContext.isOpen;
  var heightRef = useRef(null);
  var size = useDimensions(heightRef);
  var distance = axis === 'y' ? size === null || size === void 0 ? void 0 : size.borderBox.height : size === null || size === void 0 ? void 0 : size.borderBox.width;
  var containerProps = getDialogContainerProps(rootProps);
  var dialogProps = getDialogProps(rest, useMergeRefs(ref, heightRef));
  var styles = useModalStyles();
  var forceRef = useRef(0);
  var x = useMotionValue('100%');
  var y = useMotionValue('100%');
  return jsx(ModalFocusScope, {
    children: jsx(chakra.div, _objectSpread2(_objectSpread2({}, containerProps), {}, {
      __css: styles.dialogContainer,
      className: cx('hover-sheet__content-container', className, useNextThemeRootClassName()),
      pointerEvents: isOpen ? 'all' : 'none',
      tabIndex: -1,
      children: jsx(SheetDialog, _objectSpread2(_objectSpread2({
        drag: axis,
        dragConstraints: _defineProperty({}, axis === 'y' ? 'top' : 'left', 0),
        dragElastic: 0.01,
        motionParameters: {
          forceRef: forceRef
        },
        onDragEnd: onSwipe({
          axis: axis,
          force: 2500,
          distance: distance ? distance * 0.3 : undefined,
          end: function end(force) {
            forceRef.current = force;
            onClose();
          },
          none: function none() {
            return animate(axis === 'x' ? x : y, '0%',
            // @ts-expect-error
            inertiaTransition);
          }
        }),
        style: {
          x: x,
          y: y
        },
        transition: {
          duration: 0.6,
          ease: [0.32, 0.72, 0, 1]
        }
      }, dialogProps), {}, {
        __css: styles.dialog,
        children: children
      }))
    }))
  });
});
SheetContent.displayName = 'SheetContent';

var _excluded$6 = ["header", "maxContentHeight", "bodyProps", "contentKey", "footer", "children", "isClosable"],
  _excluded2$1 = ["contentProps", "children", "isClosable", "onClose"],
  _excluded3$1 = ["header", "maxContentHeight", "bodyProps", "footer", "children", "isClosable"];
var Overlay = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useModalContext = useModalContext(),
    isOpen = _useModalContext.isOpen;
  return jsx(ModalOverlay, _objectSpread2(_objectSpread2({}, props), {}, {
    pointerEvents: isOpen ? 'all' : 'none',
    ref: ref
  }));
});
var _createContext = /*#__PURE__*/createContext({
    name: 'SheetContentsRegistryContext',
    strict: true
  }),
  _createContext2 = /*#__PURE__*/_slicedToArray(_createContext, 2),
  SheetContentsRegistryProvider = _createContext2[0],
  useSheetContentsRegistry = _createContext2[1];
var MotionFlex = /*#__PURE__*/motion$1(Flex);
var SheetContents = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var header = _ref.header,
    maxContentHeightProp = _ref.maxContentHeight,
    bodyProps = _ref.bodyProps,
    contentKey = _ref.contentKey,
    footer = _ref.footer,
    children = _ref.children,
    _ref$isClosable = _ref.isClosable,
    isClosable = _ref$isClosable === void 0 ? false : _ref$isClosable,
    props = _objectWithoutProperties(_ref, _excluded$6);
  // Generally we only want to set a maximum height on content when on mobile
  // and we're opening the sheet from the bottom. Otherwise, the sheet opens
  // from the right and takes up the full height of the viewport.
  var maxContentHeight = typeof maxContentHeightProp === 'number' || typeof maxContentHeightProp === 'string' ? {
    base: maxContentHeightProp,
    tablet: '100%'
  } : maxContentHeightProp;
  var sizeRef = useRef(null);
  var size = useSize(sizeRef);
  var _useSheetContentsRegi = useSheetContentsRegistry(),
    register = _useSheetContentsRegi.register,
    registered = _useSheetContentsRegi.registered;
  useEffect(function () {
    if (size !== null && size !== void 0 && size.height && contentKey) {
      register(contentKey, size.height);
    }
  }, [contentKey, register, size === null || size === void 0 ? void 0 : size.height]);
  return jsxs(MotionFlex, _objectSpread2(_objectSpread2({
    animate: {
      opacity: 1
    },
    direction: "column",
    exit: {
      opacity: 0
    },
    initial: registered.length > 0 ? {
      opacity: 0
    } : false
  }, props), {}, {
    ref: useMergeRefs(ref, sizeRef),
    children: [header && jsx(ModalHeader, {
      children: header
    }), jsx(ModalBody, _objectSpread2(_objectSpread2({
      maxHeight: maxContentHeight
    }, bodyProps), {}, {
      children: children
    })), footer && renderFooter(footer), isClosable && jsx(ModalCloseButton, {
      variant: "minimal"
    })]
  }));
});
SheetContents.displayName = 'SheetContents';
var MotionSheetContent = /*#__PURE__*/motion$1(SheetContent);
var ChakraModalWithSheetTheme = Modal$1;
var SheetContainer = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var _registered$height, _registered;
  var contentProps = _ref2.contentProps,
    children = _ref2.children,
    _ref2$isClosable = _ref2.isClosable,
    isClosable = _ref2$isClosable === void 0 ? true : _ref2$isClosable,
    _onClose = _ref2.onClose,
    props = _objectWithoutProperties(_ref2, _excluded2$1);
  var _useTheme = useTheme(),
    components = _useTheme.components;
  var variant = props.variant;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    registered = _useState2[0],
    setContentsRegistry = _useState2[1];
  var register = useCallback(function (key, height) {
    setContentsRegistry(function (value) {
      if (value.length === 0) return [{
        key: key,
        height: height
      }];
      var last = value[value.length - 1];
      if ((last === null || last === void 0 ? void 0 : last.key) === key) return [{
        key: key,
        height: height
      }];
      return [last, {
        key: key,
        height: height
      }];
    });
  }, []);
  var axis = useBreakpointValue({
    base: 'y',
    tablet: variant === 'bottom' ? 'y' : 'x'
  });
  var height = (_registered$height = (_registered = registered[registered.length - 1]) === null || _registered === void 0 ? void 0 : _registered.height) !== null && _registered$height !== void 0 ? _registered$height : 0;
  return jsxs(ChakraModalWithSheetTheme, _objectSpread2(_objectSpread2({}, props), {}, {
    onClose: function onClose() {
      setContentsRegistry([]);
      _onClose === null || _onClose === void 0 ? void 0 : _onClose();
    },
    styleConfig: components.Sheet,
    children: [jsx(Overlay, {}), jsx(SheetContentsRegistryProvider, {
      value: {
        register: register,
        registered: registered
      },
      children: jsxs(MotionSheetContent, _objectSpread2(_objectSpread2({}, contentProps), {}, {
        axis: axis,
        ref: ref,
        children: [jsx(motion$1.div, {
          animate: registered.length > 0 ? {
            height: height
          } : undefined,
          children: children
        }), isClosable && jsx(ModalCloseButton, {
          variant: "minimal"
        })]
      }))
    })]
  }));
});
SheetContainer.displayName = 'SheetContainer';
var Sheet = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var header = _ref3.header,
    maxContentHeight = _ref3.maxContentHeight,
    bodyProps = _ref3.bodyProps,
    footer = _ref3.footer,
    children = _ref3.children,
    _ref3$isClosable = _ref3.isClosable,
    isClosable = _ref3$isClosable === void 0 ? true : _ref3$isClosable,
    props = _objectWithoutProperties(_ref3, _excluded3$1);
  return jsx(SheetContainer, _objectSpread2(_objectSpread2({}, props), {}, {
    isClosable: isClosable,
    ref: ref,
    children: jsx(SheetContents, {
      bodyProps: bodyProps,
      footer: footer,
      header: header,
      maxContentHeight: maxContentHeight,
      children: children
    })
  }));
});
Sheet.displayName = 'Sheet';
var SheetExport = /*#__PURE__*/Object.assign(Sheet, {
  Container: SheetContainer,
  Contents: SheetContents
});

var _excluded$5 = ["bodyProps", "contentProps", "children", "footer", "header", "inPortal", "isClosable", "isHover", "sx"],
  _excluded2 = ["trigger"],
  _excluded3 = ["anchor"];
var Popover = function Popover(_ref) {
  var bodyProps = _ref.bodyProps,
    contentProps = _ref.contentProps,
    children = _ref.children,
    footer = _ref.footer,
    header = _ref.header,
    inPortal = _ref.inPortal,
    isClosable = _ref.isClosable,
    isHover = _ref.isHover,
    sx = _ref.sx,
    baseProps = _objectWithoutProperties(_ref, _excluded$5);
  var _ref2 = function (p) {
      if ('trigger' in p) {
        var trigger = p.trigger,
          _rest = _objectWithoutProperties(p, _excluded2);
        return {
          TargetElement: PopoverTrigger,
          target: trigger,
          props: _rest
        };
      }
      var anchor = p.anchor,
        rest = _objectWithoutProperties(p, _excluded3);
      return {
        TargetElement: PopoverAnchor,
        target: anchor,
        props: rest
      };
    }(baseProps),
    props = _ref2.props,
    TargetElement = _ref2.TargetElement,
    target = _ref2.target;
  var nextThemeRootClassName = useNextThemeRootClassName();
  var _splitSystemProps = splitSystemProps(props),
    menuProps = _splitSystemProps.props,
    systemProps = _splitSystemProps.systemProps;
  var content = function content(renderPropProps) {
    return (
      // @ts-ignore
      jsxs(PopoverContent, _objectSpread2(_objectSpread2(_objectSpread2({
        className: inPortal ? nextThemeRootClassName : undefined
      }, systemProps), contentProps), {}, {
        sx: sx,
        children: [jsx(PopoverArrow, {}), isClosable && jsx(PopoverCloseButton, {
          size: "small",
          variant: "minimal"
        }), header && jsx(PopoverHeader, {
          children: invoke(header, renderPropProps)
        }), jsx(PopoverBody, _objectSpread2(_objectSpread2({}, bodyProps), {}, {
          children: invoke(children, renderPropProps)
        })), footer && jsx(PopoverFooter, {
          children: invoke(footer, renderPropProps)
        })]
      }))
    );
  };
  return jsx(Popover$1, _objectSpread2(_objectSpread2({
    trigger: isHover ? 'hover' : 'click'
  }, menuProps), {}, {
    children: function children(renderPropProps) {
      return jsxs(Fragment, {
        children: [jsx(TargetElement, {
          children: invoke(target, renderPropProps)
        }), inPortal ? jsx(Portal, {
          children: content(renderPropProps)
        }) : content(renderPropProps)]
      });
    }
  }));
};
Popover.displayName = 'Popover';

var _excluded$4 = ["className", "children", "sx"];
var Tooltip = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    sx = _ref.sx,
    props = _objectWithoutProperties(_ref, _excluded$4);
  // Chakra doesn't really provide any way to customize the default tooltip
  // animation, and because it uses scale and opacity it isn't disabled by
  // default by Framer's `reducedMotion` setting, so we have to override it
  // with CSS to effectively remove the motion here
  var reducedMotionStyles = useIsMotionReduced() ? {
    transform: 'scale(1) !important',
    opacity: '1 !important'
  } : {};
  return jsx(Tooltip$1, _objectSpread2(_objectSpread2({
    className: cx(className, useNextThemeRootClassName()),
    hasArrow: true,
    placement: "bottom"
  }, props), {}, {
    ref: ref,
    sx: _objectSpread2(_objectSpread2({}, reducedMotionStyles), sx),
    children: children
  }));
});
Tooltip.displayName = 'Tooltip';

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var Image = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx(Image$1, _objectSpread2(_objectSpread2({}, withTestId(props)), {}, {
    ref: ref
  }));
});
Image.displayName = 'Image';

var _excluded$3 = ["children", "noOfLines", "textOverflow", "whiteSpace", "wordBreak"];
var Badge = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$noOfLines = _ref.noOfLines,
    noOfLines = _ref$noOfLines === void 0 ? 1 : _ref$noOfLines,
    textOverflow = _ref.textOverflow,
    _ref$whiteSpace = _ref.whiteSpace,
    whiteSpace = _ref$whiteSpace === void 0 ? 'break-spaces' : _ref$whiteSpace,
    _ref$wordBreak = _ref.wordBreak,
    wordBreak = _ref$wordBreak === void 0 ? 'break-all' : _ref$wordBreak,
    props = _objectWithoutProperties(_ref, _excluded$3);
  return jsx(Badge$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: jsx(chakra.span, {
      noOfLines: noOfLines,
      overflow: "hidden",
      textOverflow: textOverflow,
      whiteSpace: whiteSpace,
      wordBreak: wordBreak,
      children: children
    })
  }));
});
Badge.displayName = 'Badge';

var _excluded$2 = ["children", "colorScheme"];
var Blockquote = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$colorScheme = _ref.colorScheme,
    colorScheme = _ref$colorScheme === void 0 ? 'primary' : _ref$colorScheme,
    props = _objectWithoutProperties(_ref, _excluded$2);
  return jsx(Alert$1, _objectSpread2(_objectSpread2({
    as: "blockquote",
    colorScheme: colorScheme
  }, withTestId(props)), {}, {
    position: "relative",
    ref: ref,
    variant: "quote",
    children: jsxs(ColorSchemeProvider, {
      colorScheme: colorScheme,
      variant: "dark",
      children: [jsx(chakra.div, {
        bg: colorScheme === 'brandTan' ? 'brandTan.400' : "".concat(colorScheme, ".200"),
        bottom: 0,
        left: 0,
        position: "absolute",
        top: 0,
        width: 50
      }), jsx(AlertDescription, {
        children: children
      })]
    })
  }));
});
Blockquote.displayName = 'Blockquote';

var focusProps = /*#__PURE__*/_objectSpread2({
  _groupFocus: {
    color: 'primary.600',
    paintOrder: 'stroke',
    strokeLinejoin: 'round',
    strokeLinecap: 'round',
    strokeWidth: '4px',
    stroke: 'primary.600',
    strokeOpacity: '0.2'
  },
  strokeOpacity: '0',
  strokeWidth: '0'
}, /*#__PURE__*/transitions(['stroke-width', 'color', 'stroke-opacity', 'transform'], motion$2.easings[250]));
var IconFocus = function IconFocus(_ref) {
  var children = _ref.children;
  var child = Children.only(children);
  var props = _objectSpread2(_objectSpread2({}, focusProps), child.props);
  return jsx(Fragment, {
    children: /*#__PURE__*/cloneElement(child, props)
  });
};

var _excluded$1 = ["children", "title", "showIndentation"];
var BorderIcon = function BorderIcon() {
  return jsx(Box, {
    "aria-hidden": "true",
    backgroundColor: "neutral.400",
    borderRadius: "2",
    flexShrink: 0,
    height: "inherit",
    marginRight: "300",
    width: "25"
  });
};
var Collapse = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$showIndentation = _ref.showIndentation,
    showIndentation = _ref$showIndentation === void 0 ? true : _ref$showIndentation,
    props = _objectWithoutProperties(_ref, _excluded$1);
  return jsx(Accordion, _objectSpread2(_objectSpread2({
    allowToggle: true,
    whiteSpace: "normal"
  }, props), {}, {
    children: jsxs(AccordionItem, {
      border: "none",
      width: "100%",
      children: [jsxs(AccordionButton, {
        _focus: {
          border: 'none'
        },
        _hover: {
          bgColor: 'none',
          cursor: 'pointer'
        },
        background: "transparent",
        border: "none",
        color: "neutral.text",
        "data-group": true,
        fontFamily: "body",
        fontWeight: "body",
        marginBottom: "3px",
        padding: "0",
        ref: ref,
        textStyle: "body500",
        children: [title, jsx(IconFocus, {
          children: jsx(AccordionIcon, {
            color: "neutral.400",
            height: "200",
            marginLeft: "100",
            width: "200"
          })
        })]
      }), jsx(AccordionPanel, {
        color: "neutral.600",
        fontFamily: "body",
        fontWeight: "body",
        padding: "0",
        textStyle: "body500",
        children: jsxs(Box, {
          children: [showIndentation && jsx(BorderIcon, {}), children]
        })
      })]
    })
  }));
});
Collapse.displayName = 'Collapse';

Table.displayName = 'Table';
Tbody.displayName = 'Tbody';
Td.displayName = 'Td';
Tfoot.displayName = 'Tfoot';
Th.displayName = 'Th';
Thead.displayName = 'Thead';
Tr.displayName = 'Tr';

var TagCloseIcon = function TagCloseIcon(_ref) {
  var width = _ref.width,
    height = _ref.height;
  return jsx(Icon$1, {
    height: height,
    verticalAlign: "inherit",
    viewBox: "0 0 12 12",
    width: width,
    children: jsx("path", {
      d: "M0.219546 10.7188C0.0789261 10.8595 -4.68466e-05 11.0503 3.66621e-08 11.2492C4.69199e-05 11.4481 0.0791097 11.6389 0.219796 11.7795C0.360481 11.9201 0.551266 11.999 0.750179 11.999C0.949092 11.999 1.13984 11.9199 1.28046 11.7792L5.91108 7.14929C5.92269 7.13765 5.93648 7.12841 5.95167 7.12211C5.96685 7.11581 5.98313 7.11257 5.99957 7.11257C6.01601 7.11257 6.03229 7.11581 6.04748 7.12211C6.06266 7.12841 6.07646 7.13765 6.08807 7.14929L10.7187 11.7802C10.7883 11.8499 10.871 11.9051 10.962 11.9428C11.053 11.9806 11.1505 12 11.249 12C11.3475 12 11.445 11.9806 11.536 11.943C11.627 11.9053 11.7097 11.8501 11.7794 11.7805C11.849 11.7108 11.9043 11.6282 11.942 11.5372C11.9797 11.4462 11.9991 11.3487 11.9991 11.2502C11.9992 11.1517 11.9798 11.0542 11.9421 10.9632C11.9045 10.8722 11.8492 10.7895 11.7796 10.7198L7.14948 6.08792C7.13784 6.07631 7.1286 6.06251 7.1223 6.04733C7.116 6.03215 7.11276 6.01587 7.11276 5.99943C7.11276 5.98299 7.116 5.96671 7.1223 5.95153C7.1286 5.93634 7.13784 5.92255 7.14948 5.91094L11.7806 1.28051C11.9212 1.1397 12.0001 0.948793 12 0.749794C11.9999 0.550796 11.9207 0.360004 11.7799 0.21939C11.639 0.0787765 11.4481 -0.000140445 11.2491 1.87636e-07C11.0501 0.00014082 10.8593 0.0793275 10.7187 0.22014L6.08807 4.84957C6.07646 4.86121 6.06266 4.87044 6.04748 4.87674C6.03229 4.88304 6.01601 4.88629 5.99957 4.88629C5.98313 4.88629 5.96685 4.88304 5.95167 4.87674C5.93648 4.87044 5.92269 4.86121 5.91108 4.84957L1.28046 0.22014C1.21083 0.150482 1.12816 0.0952205 1.03718 0.0575095C0.946193 0.0197985 0.848671 0.000376896 0.750179 0.000353684C0.551266 0.000306805 0.360481 0.0792764 0.219796 0.21989C0.0791097 0.360504 4.69011e-05 0.551243 2.086e-08 0.750148C-4.68594e-05 0.949053 0.078926 1.13983 0.219546 1.28051L4.84967 5.91094C4.86131 5.92255 4.87054 5.93634 4.87684 5.95153C4.88314 5.96671 4.88639 5.98299 4.88639 5.99943C4.88639 6.01587 4.88314 6.03215 4.87684 6.04733C4.87054 6.06251 4.86131 6.07631 4.84967 6.08792L0.219546 10.7188Z",
      fill: "currentColor"
    })
  });
};

var _excluded = ["children", "showClose", "icon", "onClose"];
var Tag = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    showClose = _ref.showClose,
    icon = _ref.icon,
    onClose = _ref.onClose,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useMultiStyleConfig('Tag', props);
  return jsxs(Tag$1, _objectSpread2(_objectSpread2({}, props), {}, {
    ref: ref,
    children: [icon && jsx(TagLeftIcon, {
      as: Icon,
      icon: icon,
      margin: "0",
      sx: styles.icon
    }), jsx(TagLabel, {
      children: children
    }), showClose && jsx(TagCloseButton, {
      onClick: onClose,
      children: jsx(TagCloseIcon, {})
    })]
  }));
});
Tag.displayName = 'Tag';

export { Alert as A, Body as B, CheckboxGroup as C, Dialog as D, MenuItemOption as E, Field as F, Code as G, useBreakpoint as H, Image as I, useBreakpointValue as J, useReducedMotionVariants as K, LoadingOverlay as L, Message as M, useTimeoutFlag as N, Provider$1 as O, Panel as P, pickThemingProps as Q, splitLayoutProps as R, Slider as S, ToggleButtonGroupProvider as T, splitSystemProps as U, systemPropNames as V, layoutPropNames as W, onSwipe as X, SWIPE_THRESHOLD as Y, _objectDestructuringEmpty as Z, _extends as _, useToggleButtonProps as a, TileCheckbox as b, componentMessage as c, Toggle as d, Badge as e, Blockquote as f, getToggleButtonGroupProps as g, Collapse as h, Tag as i, Checkbox as j, Check as k, Select as l, StepperInput as m, TextInput as n, TileRadio as o, TabHeading as p, Drawer as q, FilterMenu as r, LoadingState as s, Modal as t, useContext as u, SheetExport as v, Popover as w, Tooltip as x, Menu as y, MenuButton as z };
